export default __webpack_public_path__ + "static/media/css3.9058bae4.png";